import React, { useState } from "react";
import { Link } from "react-router-dom";
import Sidebar from "../../partials/aside/Sidebar";
import TitleBar from "../../partials/content/TitleBar";
import TypePageConstant from "./TypePageConstant";
import ButtonDisable from "../../partials/other/ButtonDisable";

export default function AddPage() {
  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar title="اضافه کردن صفحه به سایت batmatic-test.ir" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div className="text-left pb-2">
                <Link className="btn btn-primary" to="/page/all/publisher/1">
                  <span>بازگشت</span>
                  <span className="pr-2">
                    <i className="fas fa-arrow-left"></i>
                  </span>
                </Link>
              </div>
              <div id="message-box"> </div>
              <div className="alert alert-warning">
                <p className="text-justify">
                  <i className="fa fa-info pl-2"></i>
                  توجه داشته باشید :{" "}
                </p>
                <ul className="pr-3">
                  <li>
                    <p className="text-justify">
                      برای آپلود عکس صفحه فقط از فرمت webp استفاده کنید .
                    </p>
                  </li>
                  <li>
                    <p className="text-justify">
                      <span>الگو آدرس حتما باید با حرف / شروع شود و فاقد</span>
                      <span dir="ltr" className="px-2">
                        https://
                      </span>
                      <span>و دامنه سایت شما باشد.</span>
                    </p>
                  </li>
                  <li>
                    <p className="text-justify">
                      اگر نوع صفحه شما چند صفحه ای است الگو آدرس شما باید دارای
                      s@ باشد.
                    </p>
                  </li>

                  <hr />
                  <li>
                    <p className="text-justify">
                      برای ایجاد آدرس , صفحات ثابت بصورت زیر , آدرس را درج کنید
                    </p>
                  </li>
                  <li>
                    <p className="text-justify">
                      <span className="pl-2">عنوان : </span>
                      <span className="pl-2">تماس با ما</span>
                      <span className="pl-2">-</span>
                      <span className="pl-2">الگو آدرس :</span>
                      <span className="pl-2" dir="ltr">
                        /contact-us
                      </span>
                      <span className="pl-2">-</span>
                      <span className="pl-2">لینک : </span>
                      <span dir="ltr" className="pl-2">
                        https://monirlock.ir/contact-us
                      </span>
                    </p>
                  </li>
                  <li>
                    <p className="text-justify">
                      <span className="pl-2">عنوان : </span>
                      <span className="pl-2">درباره با ما</span>
                      <span className="pl-2">-</span>
                      <span className="pl-2">الگو آدرس : </span>
                      <span className="pl-2" dir="ltr">
                        /about-us
                      </span>
                      <span className="pl-2">-</span>
                      <span className="pl-2">لینک : </span>
                      <span dir="ltr" className="pl-2">
                        https://monirlock.ir/about-us
                      </span>
                    </p>
                  </li>
                  <hr />
                  <li>
                    <p className="text-justify">
                      برای ایجاد آدرس , صفحات متغیر بصورت زیر , آدرس را درج کنید
                    </p>
                  </li>
                  <li>
                    <p className="text-justify">
                      <span className="pl-2">عنوان : </span>
                      <span className="pl-2">صفحات محصولات</span>
                      <span className="pl-2">-</span>
                      <span className="pl-2">الگو آدرس : </span>
                      <span className="pl-2" dir="ltr">
                        /product/@s
                      </span>
                      <span className="pl-2">-</span>
                      <span className="pl-2">لینک : </span>
                      <span dir="ltr" className="pl-2">
                        https://monirlock.ir/product/10941
                      </span>
                    </p>
                  </li>
                  <li>
                    <p className="text-justify">
                      <span className="pl-2">عنوان : </span>
                      <span className="pl-2">صفحات مطالب</span>
                      <span className="pl-2">-</span>
                      <span className="pl-2">الگو آدرس : </span>
                      <span className="pl-2" dir="ltr">
                        /blog/@s
                      </span>
                      <span className="pl-2">-</span>
                      <span className="pl-2">لینک : </span>
                      <span dir="ltr" className="pl-2">
                        {decodeURI(
                          "https://monirlock.ir/blog/%d8%a7%d9%86%d9%88%d8%a7%d8%b9-%da%a9%d9%84%db%8c%d8%af-%d9%87%d8%a7%db%8c-%d9%85%d9%86%db%8c%d8%b1-%d8%b5%d9%86%d8%b9%d8%aa"
                        )}
                      </span>
                    </p>
                  </li>
                  <hr />
                  <li>
                    <p className="text-justify">
                      برای ایجاد آدرس , صفحه اصلی , آدرس زیر را درج کنید
                    </p>
                  </li>
                  <li>
                    <p className="text-justify">
                      <span className="pl-2">عنوان : </span>
                      <span className="pl-2">صفحه اصلی</span>
                      <span className="pl-2">-</span>
                      <span className="pl-2">الگو آدرس : </span>
                      <span className="pl-2" dir="ltr">
                        /
                      </span>
                      <span className="pl-2">-</span>
                      <span className="pl-2">لینک : </span>
                      <span dir="ltr" className="pl-2">
                        https://monirlock.ir
                      </span>
                    </p>
                  </li>
                  <li>
                    <p className="text-justify">
                      برای ایجاد آدرس , صفحه چند صفحه ای بدون پیش وند , آدرس زیر
                      را درج کنید
                    </p>
                  </li>
                  <li>
                    <p className="text-justify">
                      <span className="pl-2">عنوان : </span>
                      <span className="pl-2">صفحات مطالب</span>
                      <span className="pl-2"> - </span>
                      <span className="pl-2">الگو آدرس : </span>
                      <span className="pl-2" dir="ltr">
                        /@s
                      </span>
                      <span className="pl-2">-</span>
                      <span className="pl-2">لینک : </span>
                      <span dir="ltr" className="pl-2">
                        {decodeURI(
                          "https://monirlock.ir/%d8%a7%d9%86%d9%88%d8%a7%d8%b9-%da%a9%d9%84%db%8c%d8%af-%d9%87%d8%a7%db%8c-%d9%85%d9%86%db%8c%d8%b1-%d8%b5%d9%86%d8%b9%d8%aa"
                        )}
                      </span>
                    </p>
                  </li>
                </ul>
              </div>

              <form>
                <div className="form-group">
                  <label>عنوان</label>
                  <input
                    tabIndex="1"
                    dir="rtl"
                    type="text"
                    id="title"
                    className="form-control"
                    required
                  />
                </div>
                <div className="form-group">
                  <label>نوع صفحه</label>
                  <div className="d-inline-block pr-2">
                    <select className="form-control">
                      <option value={TypePageConstant.typePage.STATIC}>
                        {
                          TypePageConstant.typePageString()[
                            TypePageConstant.typePage.STATIC
                          ]
                        }
                      </option>
                      <option value={TypePageConstant.typePage.MULTI_PAGE}>
                        {
                          TypePageConstant.typePageString()[
                            TypePageConstant.typePage.MULTI_PAGE
                          ]
                        }
                      </option>
                    </select>
                  </div>
                </div>
                <div className="form-group">
                  <label>الگو آدرس</label>
                  <input
                    tabIndex="3"
                    dir="ltr"
                    type="text"
                    id="pattern"
                    className="form-control"
                    required
                  />
                </div>
                <div className="form-group">
                  <label>لینک صفحه </label>
                  <input
                    tabIndex="4"
                    dir="ltr"
                    type="text"
                    id="link"
                    className="form-control"
                    required
                  />
                </div>

                <div className="form-group">
                  <span className="pl-2">
                    <label>فعال</label>
                  </span>
                  <span>
                    <label className="adl-switch">
                      <input type="checkbox" id="active" />
                      <span className="adl-slider round"></span>
                    </label>
                  </span>
                </div>

                <div className="form-group">
                  <div>
                    <label>عکس صفحه</label>
                  </div>
                  <div>
                    <input
                      type="file"
                      id="image-file"
                      accept="image/webp"
                      required
                    />
                  </div>
                </div>
                <div className="form-group">
                  <ButtonDisable
                    buttonTagHtml={
                      <span className="btn btn-success opacity-50">
                        اضافه کردن
                      </span>
                    }
                  ></ButtonDisable>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
